import React from "react";
import { useTranslation } from "react-i18next";

const DepositHeader: React.FC = () => {
  const { t } = useTranslation("deposits\\deposits");

  return (
    <div className="row no-gutters d-none d-sm-flex text-muted font-weight-bold align-items-center py-2">
      <div className="col px-3">
        <div className="row no-gutters">
          <div className="col-sm-2"> {t("depositHeader.paymentDate")} </div>
          <div className="col-2">    {t("depositHeader.depositType")} </div>
          <div className="col-sm-3"> {t("depositHeader.amount")}      </div>
          <div className="col-sm-5"> {t("depositHeader.used")}        </div>
        </div>
      </div>

      <div className="col-auto px-2" />
    </div>
  );
};

export default DepositHeader;
